import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/design-system.css';
import App from './App';
import { I18nProvider } from './i18n';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
